import React, { FC } from 'react';

import homepageTranslations from 'public/locales/en/homepage.json';
import { SearchInitiation } from 'shared/components/SearchInitiation';
import { getTranslator } from '../../../shared/i18n/getTranslator';
import { BuyRentTabs } from '../BuyRentTabs/BuyRentTabs';
import { HeroContainerProps } from './HeroContainer.types';
import {
    SearchInitiationWrapper,
    SearchInputWrapper,
    MainHeadlineMobile,
    MainHeadlineDesktop,
    SearchInitiationButton,
    SearchBarWrapper,
    SearchInputTitle,
    HeroImage
} from './HeroContainer.styles';

const t = getTranslator(homepageTranslations);

const searchInitiationButtonText = t('search_initiation_button');

export const HeroContainer: FC<HeroContainerProps> = ({
    openModal,
    tabSelected,
    setTabSelected,
    brandHeadline,
    title,
    image = {}
}) => {
    const {
        focalPoint: { focalPoint } = {},
        altText,
        image: { url, width, height } = {}
    } = image;

    const onClickSearchInitiationButton = () => {
        openModal('search_initiation');
    };

    return (
        <>
            <SearchInitiationWrapper>
                <SearchInitiationButton
                    testId={'search-intitiation-mobile-button'}
                    buttonColor="white"
                    iconColor="white"
                    hoverColor="white"
                    backgroundColor="primary-brand"
                    iconId="search"
                    iconIdHover="search"
                    content={searchInitiationButtonText}
                    onClick={onClickSearchInitiationButton}
                    size="medium"
                    hasBorder={false}
                />

                <HeroImage
                    src={url || ''}
                    focalPoint={focalPoint}
                    width={width || 0}
                    height={height || 0}
                >
                    <span role="img" aria-label={altText}></span>
                </HeroImage>

                <MainHeadlineMobile size="1" color="white">
                    {brandHeadline}
                </MainHeadlineMobile>

                <SearchInputWrapper>
                    <>
                        <SearchInputTitle>{title}</SearchInputTitle>
                        <BuyRentTabs
                            onPress={setTabSelected}
                            selected={tabSelected}
                            includeHousePrices
                        />
                        <SearchBarWrapper>
                            <SearchInitiation
                                hasRadius={false}
                                searchType={tabSelected}
                            />
                        </SearchBarWrapper>
                        <MainHeadlineDesktop color="white">
                            {brandHeadline}
                        </MainHeadlineDesktop>
                    </>
                </SearchInputWrapper>
            </SearchInitiationWrapper>
        </>
    );
};
